import { useEffect, useRef, useState } from "react";
import { Copy, Check } from "lucide-react";

// Codici di recupero: copia negli appunti con conferma solo a copia riuscita, altrimenti selezione manuale.
export function RecoveryCodes({ codes, dark = false }) {
  const [state, setState] = useState("idle");
  const area = useRef(null);
  const text = codes.join("\n");
  useEffect(() => {
    if (state === "manual") { area.current?.focus(); area.current?.select(); }
  }, [state]);
  const copy = async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("no-clipboard");
      await navigator.clipboard.writeText(text);
      setState("ok");
    } catch {
      setState("manual");
      area.current?.select();
    }
  };
  const muted = dark ? "text-white/70" : "text-neutral-600";
  return (
    <div data-testid="recovery-codes">
      <div className="grid grid-cols-2 gap-2 font-mono text-sm mb-3" data-testid="mfa-recovery-list">
        {codes.map((c) => <div key={c} className={`px-2 py-1 rounded text-center ${dark ? "bg-white/10" : "bg-neutral-100"}`}>{c}</div>)}
      </div>
      <button type="button" onClick={copy} data-testid="mfa-recovery-copy" className="text-xs underline flex items-center gap-1 mb-2">
        {state === "ok" ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />} {state === "ok" ? "Codici copiati negli appunti" : "Copia i codici di recupero"}
      </button>
      {state === "ok" && <p className={`text-xs mb-2 ${muted}`} data-testid="mfa-recovery-copy-ok">Copiati {codes.length} codici, uno per riga. Incollali subito nel gestore di password.</p>}
      {state === "manual" && (
        <div className="mb-2" data-testid="mfa-recovery-manual">
          <p className="text-xs mb-1 text-amber-500" data-testid="mfa-recovery-copy-denied">Il browser non consente la copia automatica. Il testo qui sotto è già selezionato: copialo con Ctrl+C (Cmd+C su Mac) o tieni premuto e scegli Copia.</p>
          <textarea ref={area} readOnly value={text} rows={codes.length} onFocus={(e) => e.target.select()} data-testid="mfa-recovery-textarea"
            className={`w-full font-mono text-sm p-2 rounded border ${dark ? "bg-white/5 border-white/20 text-white" : "bg-white"}`} />
        </div>
      )}
    </div>
  );
}
